import { Context, useContext } from 'react';

export const useNonNullContext = <T>(context: Context<T | null>): T => {
  const contextValue = useContext(context);
  if (contextValue === null) {
    throw new Error(`Expecting context to not be null ${context.displayName || context.toString()}`);
  }
  return contextValue;
};
